"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./InputField.css");

require("./InputField.scss");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _IconDropdown = _interopRequireDefault(require("../other/IconDropdown"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Our main component
var InputField = /*#__PURE__*/function (_Component) {
  _inherits(InputField, _Component);

  var _super = _createSuper(InputField);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _super.call(this, props);
    _this.state = {
      dropdown: false,
      dropdown_content: []
    };
    _this.keyDownHandler = _this.keyDownHandler.bind(_assertThisInitialized(_this));
    return _this;
  } // Handles the dropdown result if the user
  // has sent a list with results


  _createClass(InputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dropdown_result = this.props.dropdown_result;
      dropdown_result && this.setState({
        dropdown_content: dropdown_result
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var dropdown_result = this.props.dropdown_result;
      if (dropdown_result !== prevProps.dropdown_result) this.setState({
        dropdown_content: dropdown_result
      });
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      if (e.keyCode === 13) if (this.state.dropdown_content.length > 0) this.props.onKeyDown(this.state.dropdown_content[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          cta_click = _this$props.cta_click,
          cta_icon = _this$props.cta_icon,
          disabled = _this$props.disabled,
          error = _this$props.error,
          icon = _this$props.icon,
          _onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          _onFocus = _this$props.onFocus,
          _onKeyDown = _this$props.onKeyDown,
          _onMouseDown = _this$props.onMouseDown,
          pattern = _this$props.pattern,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? 'Input placeholder' : _this$props$placehold,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'L' : _this$props$size,
          template = _this$props.template,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? 'text' : _this$props$type,
          value = _this$props.value,
          iconPicker = _this$props.iconPicker,
          maxLength = _this$props.maxLength,
          title = _this$props.title,
          label = _this$props.label,
          max = _this$props.max,
          name = _this$props.name,
          defaultValue = _this$props.defaultValue,
          refer = _this$props.refer,
          _this$state = this.state,
          dropdown = _this$state.dropdown,
          dropdown_content = _this$state.dropdown_content;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "inputFieldWrapper ".concat(className, " ").concat(size)
      }, title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "form__group field"
      }, icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: icon
      }), /*#__PURE__*/_react["default"].createElement("input", {
        ref: refer,
        defaultValue: defaultValue,
        name: name && name,
        max: max && max,
        "aria-label": label,
        maxLength: maxLength,
        className: "form__field inputField ".concat(error ? 'error' : '', " ").concat(icon ? 'input_icon' : '', " ").concat(template ? "temp_".concat(template) : ''),
        onBlur: function onBlur(e) {
          _onBlur && _onBlur(e);

          _this2.setState({
            dropdown: false
          });
        },
        onChange: onChange,
        onFocus: function onFocus(e) {
          _onFocus && _onFocus(e);

          _this2.setState({
            dropdown: true
          });
        },
        onKeyDown: function onKeyDown(e) {
          _onKeyDown && _onKeyDown(e);

          _this2.keyDownHandler(e);
        },
        placeholder: title ? title : placeholder,
        style: {
          backgroundPosition: icon && '5px center',
          backgroundRepeat: icon && 'no-repeat',
          backgroundSize: icon && '15px',
          paddingLeft: icon || iconPicker ? '40px' : '',
          paddingRight: cta_icon && '40px'
        },
        type: type,
        pattern: pattern,
        value: value,
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: name,
        className: "".concat(icon ? "has_icon" : "", " form__label")
      }, title)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: icon
      }), iconPicker && /*#__PURE__*/_react["default"].createElement(_IconDropdown["default"], {
        active: this.state.active_icon,
        onChange: function onChange(e) {
          return _this2.setState({
            active_icon: e
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("input", {
        ref: refer,
        defaultValue: defaultValue,
        name: name && name,
        max: max && max,
        "aria-label": label,
        maxLength: maxLength,
        className: "inputField ".concat(error ? 'error' : '', " ").concat(icon ? 'input_icon' : '', " ").concat(template ? "temp_".concat(template) : ''),
        onBlur: function onBlur(e) {
          _onBlur && _onBlur(e);

          _this2.setState({
            dropdown: false
          });
        },
        onChange: onChange,
        onFocus: function onFocus(e) {
          _onFocus && _onFocus(e);

          _this2.setState({
            dropdown: true
          });
        },
        onKeyDown: function onKeyDown(e) {
          _onKeyDown && _onKeyDown(e);

          _this2.keyDownHandler(e);
        },
        placeholder: title ? "" : placeholder,
        style: {
          backgroundPosition: icon && '5px center',
          backgroundRepeat: icon && 'no-repeat',
          backgroundSize: icon && '15px',
          paddingLeft: icon || iconPicker ? '40px' : '',
          paddingRight: cta_icon && '40px'
        },
        type: type,
        pattern: pattern,
        value: value,
        disabled: disabled
      }), cta_icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        animated: true,
        className: "inputFieldCtaIcon",
        name: cta_icon,
        onClick: cta_click ? cta_click : undefined
      }), dropdown && dropdown_content.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "inputFieldDropdown"
      }, dropdown_content.map(function (value, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "inputFieldDropdownOption",
          key: index,
          onMouseDown: function onMouseDown() {
            return _onMouseDown ? _onMouseDown(value) : undefined;
          }
        }, typeof value === 'string' ? value : _typeof(value) === 'object' && Object.entries(value).map(function (_ref, index) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              val = _ref2[1];

          return key !== 'id' && /*#__PURE__*/_react["default"].createElement("span", {
            key: index
          }, typeof val === 'string' ? val.replace(/_/g, ' ') : val);
        }));
      }))));
    }
  }]);

  return InputField;
}(_react.Component);

exports["default"] = InputField;